import { merge } from "lodash/fp";
import { HubThemePartial } from "../../types";
import xdiThemeBase from "./_base";

const xdiTheme = merge(xdiThemeBase, {
  meta: {
    config: {
      hazards: {
        available: [
          "coastal_inundation",
          "cyclone_wind",
          "flood_riverine",
          "flood_surfacewater",
          "forest_fire",
          "freeze_thaw",
          "heat",
          "soil_movement",
          "wind",
          "cyclone_storm_surge",
        ],
      },
    },
  },
} as HubThemePartial);

export default xdiTheme;
